import type { TutorPaymentPolicySelectReturn } from './interfaces'

import { TutorCategoryType } from '@entities/tutor'

import { usePaymentPoliciesStore } from './store'
import { useTutorPaymentPolicySelect } from './tutor-payment-policy-select.hook'

export const useSelectDemoMath = (): TutorPaymentPolicySelectReturn => {
  const paymentPoliciesStore = usePaymentPoliciesStore()

  return useTutorPaymentPolicySelect({
    category: TutorCategoryType.DemoMath,
    label: 'Demo Math',
    getValue: () => paymentPoliciesStore.selectedDemoMath as number | null,
    setValue: (value) => paymentPoliciesStore.setSelectedDemoMath(value),
  })
}
